export enum RateSource {
  FlatRate = 'FLAT',
  UserExternalRate = 'USER',
  SeniorityBasedRate = 'SENIORITY',
  RoleBasedRate = 'ROLE',
  GlobalDefaultRate = 'ORGANIZATION',
  ProjectRateCard = 'RATE_CARD',
  Custom = 'CUSTOM',
  ProjectBased = 'PROJECT_BASED', // Project-based rate (uses projectBasedRateOption source)
}
